import React from "react";
import Banner from "../Banner/Banner";
import ContactForm from "../ContactForm/ContactForm";
import ProjectCard from "../ProjectCard/ProjectCard";
import Navigation from "../../Shared/Navigation/Navigation";
import AboutMe from "../AboutMe/AboutMe";
import Blog from "../Blog/Blog";


const Home = () => {
  return (
    <div>
      <Navigation></Navigation>
      <Banner></Banner>
      <AboutMe></AboutMe>
      <ProjectCard></ProjectCard>
      <ContactForm></ContactForm>
    </div>
  );
};

export default Home;
